module.exports = __webpack_public_path__ + "SC04.36b83b0d.atlas";